import { render, staticRenderFns } from "./Sticker.vue?vue&type=template&id=55e016d8&scoped=true&lang=pug"
import script from "./Sticker.vue?vue&type=script&lang=js"
export * from "./Sticker.vue?vue&type=script&lang=js"
import style0 from "./Sticker.vue?vue&type=style&index=0&id=55e016d8&prod&scoped=true&lang=sass"
import style1 from "./Sticker.vue?vue&type=style&index=1&id=55e016d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e016d8",
  null
  
)

export default component.exports